module.exports = __webpack_public_path__ + "media/images/application/icons/mail-1ee49004acc8cb4bd5b8928475859427.svg";